import React, { ReactNode, ChangeEvent } from 'react'
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  SelectProps,
  SelectChangeEvent
} from '@mui/material'
// @ts-expect-error - Import needs esModuleInterop flag
import { useTranslation } from '@contexts/translation'

interface SelectUncontrolledProps {
  /** Field name */
  name: string
  /** Label text for the field */
  label: string
  /** Whether the component is in a loading state */
  isLoading?: boolean
  /** Child components to render inside the select */
  children?: ReactNode
  /** Function to call when the select value changes */
  onChangeEvent: (event: SelectChangeEvent<unknown>) => void
  /** Current value of the select */
  data: unknown
  /** Whether the component takes up the full width */
  fullWidth?: boolean
  /** Additional props to pass to the Select component */
  [key: string]: any
}

/**
 * SelectUncontrolled component
 * An uncontrolled select component for use in forms
 */
const SelectUncontrolled = ({
  name,
  label,
  isLoading = false,
  children,
  onChangeEvent,
  data,
  fullWidth = false,
  ...props
}: SelectUncontrolledProps): JSX.Element => {
  const { dictionary } = useTranslation()

  return (
    <FormControl fullWidth variant="filled" margin="normal">
      <InputLabel id={`${name}-label`}>
        {isLoading ? dictionary.loading?.toString() || 'Loading...' : label}
      </InputLabel>
      <Select
        fullWidth={fullWidth}
        name={name}
        labelId={`${name}-label`}
        value={isLoading ? [] : data}
        onChange={onChangeEvent}
        {...props}
        data-testid="Select-4d67518f-ae8b-4e58-9e20-06e05384b15e"
      >
        {!Array.isArray(children) || children.length === 0 ? (
          <MenuItem
            disabled
            value=""
            data-testid="MenuItem-d576dba0-7920-4f45-a30f-acc99f6886d4"
          >
            {dictionary.no_data?.toString() || 'No data'}
          </MenuItem>
        ) : (
          children
        )}
      </Select>
    </FormControl>
  )
}

export default SelectUncontrolled
